export default "__VITE_ASSET__CCMNn0dd__"